import { Predicate } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IServiceOpcode } from '@signal/asp-data-commons';
import { FeatureKeys } from '../app.reducer';
import { transformOpcodeData } from './opcode.adapter';
import * as fromReducer from './opcode.reducer'


export const selectOpCodeFeature = createFeatureSelector<fromReducer.OpCodeState>(FeatureKeys.OPCODE);

export const selectAllOpCodesState = createSelector(
  selectOpCodeFeature,
  (opCodeState: fromReducer.OpCodeState) => opCodeState.allOpCodes
)

export const selectOnlineOpCodesState = createSelector(
  selectOpCodeFeature,
  (opCodeState: fromReducer.OpCodeState) => opCodeState.onlineOpCodes
)

export const selectMileagesState = createSelector(
  selectOpCodeFeature,
  (opCodeState: fromReducer.OpCodeState) => opCodeState.mileages
)

export const selectOnlineSortingDetails = createSelector(
  selectOpCodeFeature,
  (opCodeState: fromReducer.OpCodeState) => opCodeState.onlineSortOrder
)

export const selectOpCodes = createSelector(
  selectAllOpCodesState,
  fromReducer.allOpCodesAdapter.getSelectors().selectAll
);

export const selectOpcodeById = createSelector(
  selectAllOpCodesState,
  (state: fromReducer.AllOpCodeState, props: { id: string }) => state.entities[props.id]
);

export const selectOnlineOpCodes = createSelector(
  selectOnlineOpCodesState,
  fromReducer.onlineOpCodesAdapter.getSelectors().selectAll
);

export const miscOpcode = createSelector(
  selectOnlineOpCodesState,
  (state: fromReducer.OnlineOpCodeState) => Object.keys(state.entities).filter(t => state.entities[t].isMiscellaneous)
)

export const selectMileages = createSelector(
  selectMileagesState,
  fromReducer.mileagesAdapter.getSelectors().selectAll
)

export const selectAllOpCodes = createSelector(
  selectOpCodes,
  (opCodes: IServiceOpcode[]) => opCodes
);

export const selectDmsOpCodes = createSelector(
  selectOpCodes,
  (opCodes: IServiceOpcode[]) => opCodes.filter(x=> !x?.isInternalCode)
);

export const selectAllTransformedOpCodes = createSelector(
  selectOpCodes,
  (opCodes: IServiceOpcode[]) => transformOpcodeData(opCodes)
);

export const selectOnlineOpCodesList = createSelector(
  selectOnlineOpCodes,
  (opCodes: IServiceOpcode[]) => opCodes
);

export const selectOnlineTransformedOpCodes = createSelector(
  selectOnlineOpCodesList,
  (opCodes: IServiceOpcode[]) => transformOpcodeData(opCodes)
);
export const selectOnlineOpCodesListLength = createSelector(
  selectOnlineOpCodesList,
  (opCodes: IServiceOpcode[]) => opCodes.length
);

export const selectCurrentOpCodeDetails = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => (state.allOpCodes.ids as string[]).indexOf(state.selectedOpCode) > -1 ?
    state.allOpCodes.entities[state.selectedOpCode] : state.onlineOpCodes.entities[state.selectedOpCode]
);



export const selectAllOpCodeCount = createSelector(
  selectAllOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.opCodeCount
);

export const selectOnlineOpCodeCount = createSelector(
  selectOnlineOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.opCodeCount
);

export const selectOnlineOpCodesByPredicate = createSelector(
  selectOnlineOpCodesList,
  (service: IServiceOpcode[], props: { predicate: Predicate<IServiceOpcode> }) => service.filter(props.predicate)
);

export const selectUpdateOpCodeLoading = createSelector(
  selectAllOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.loading
);
export const selectIsOpcodeExists = createSelector(
  selectAllOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.isOpcodeExists
);

export const selectFromAllOpCodes = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => state.allOpCodes.entities[state.selectedOpCode]
);

export const selectFromOnlineOpCodes = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => state.onlineOpCodes.entities[state.selectedOpCode]
);

export const selectLoading = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => state.allOpCodes.loading
);

export const selectAllMileages = createSelector(
  selectMileages,
  (mileages: number[]) => mileages
);

export const selectOnlineServicesSortOrder = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => state.onlineSortOrder.onlineCustomSortOrder
);

export const selectSyncStatus = createSelector(
  selectOpCodeFeature,
  (state: fromReducer.OpCodeState) => state.allOpCodes.syncStatus
);

export const selectIsAspCodeCreated = createSelector(
  selectAllOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.isAspCodeCreated
);
export const selectOnlineOpCodeLoading = createSelector(
  selectOnlineOpCodesState,
  (state: fromReducer.AllOpCodeState) => state.loading
);